import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import API from '../api/axios';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import { useTheme } from '../context/ThemeContext';
import '../style/login.css';
import { GoogleLogin } from '@react-oauth/google';

export default function Login() {
  const { login } = useContext(AuthContext);
  const { darkMode } = useTheme();
  const [form, setForm] = useState({ email: '', password: '' });
  // const [error, setError] = useState(''); by rajan
  const [errorModal, setErrorModal] = useState({ show: false, message: '' }); // invalid credintial
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post('/auth/login', form);
      localStorage.setItem('token', res.data.token);
      login(res.data.user);
      navigate('/');
      // } catch (err) {
      //   setError(err.response?.data?.error || 'Login failed');
      // }
    } catch (err) {
      setErrorModal({
        show: true,
        message: err.response?.data?.error || 'Invalid Email or Password. Please check your credentials and try again!'
      });
    }      // by rajan
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      //  JWT token by Google 
      const res = await API.post('/auth/google', {
        token: credentialResponse.credential
      });

      // Backend verify karke apna token aur user bhejta hai
      localStorage.setItem('token', res.data.token);
      login(res.data.user);
      navigate('/');
    } catch (err) {
      console.error("Google Login Error", err);
      setErrorModal({
        show: true,
        message: err.response?.data?.error || 'Google Login failed. Please try again!'
      });
    }
  };

  const handleGoogleError = () => {
    setErrorModal({
      show: true,
      message: 'Google Sign-In was unsuccessful. Try again!'
    });
  };
  // by - rajan 

  return (
    <div className={`login-page ${darkMode ? 'dark' : 'light'}`}>
      <div className="login-card">
        <h2>🔐 Welcome Back</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />
          <button type="submit">Login</button>
        </form>
        {/* {error && <p className="error">{error}</p>} - by rajan */}
        {/* Attractive Login Error Modal Popup */}

        {/* google sign in button */}
        <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            theme={darkMode ? 'filled_black' : 'outline'}
            shape="pill"
          />
        </div>
        {/* by rajan */}

        {errorModal.show && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            zIndex: 3000, backdropFilter: 'blur(3px)'
          }}>
            <div style={{
              backgroundColor: darkMode ? '#111926' : '#FFFFFF',
              color: darkMode ? '#FFFFFF' : '#222222',
              padding: '2rem',
              borderRadius: '16px',
              maxWidth: '380px',
              width: '85%',
              textAlign: 'center',
              boxShadow: '0 10px 30px rgba(239, 68, 68, 0.3)',
              border: '2px solid #EF4444'
            }}>
              <div style={{ fontSize: '2.8rem', marginBottom: '0.5rem' }}>❌</div>
              <h3 style={{ color: '#EF4444', marginBottom: '0.4rem', fontSize: '1.4rem' }}>Login Failed</h3>
              <p style={{ opacity: 0.9, marginBottom: '1.5rem', fontSize: '0.92rem', lineHeight: '1.4' }}>
                {errorModal.message}
              </p>
              <button
                onClick={() => setErrorModal({ show: false, message: '' })}
                style={{
                  backgroundColor: '#EF4444',
                  color: '#FFFFFF',
                  border: 'none',
                  padding: '0.65rem 1.8rem',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: '0.9rem'
                }}
              >
                Try Again
              </button>
            </div>
          </div>
        )}
        {/* above code - by rajan  */}
      </div>

      {/* footer spaced from content */}
      <div style={{ marginTop: '5rem' }}>
        <Footer />
      </div>
    </div>
  );
}